import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { formatNumber } from "../../utils/formatNumber";

export default function SnapshotItemsDialog({ open, onClose, items }) {
  const columns = [
    { field: "no", headerName: "ลำดับ", width: 70 },
    { field: "code", headerName: "รหัสสินค้า", width: 100 },
    { field: "title", headerName: "ชื่อสินค้า", flex: 2 },
    {
      field: "price",
      headerName: "ราคาสินค้า",
      flex: 1,
      renderCell: (params) => formatNumber(params.value),
      align: "right",
      headerAlign: "right",
    },
  ];

  const rows = items.map((item, idx) => ({
    id: item.id,
    no: idx + 1,
    ...item,
  }));

  console.log('items',items);
  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>รายการสินค้า</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1 }}>
          <DataGrid
            rows={rows}
            columns={columns}
            pageSizeOptions={[10]}
            initialState={{
              pagination: { paginationModel: { page: 0, pageSize: 10 } },
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained" color="primary">
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
